import React from 'react';
import { theme } from '../../../../ui';
import { toRgba } from '../../../../ui/theme/colors';
import styled from 'styled-components';
import { drawerWidthMinimal, drawerWidthResponsive, drawerWidthResponsiveCompact } from '../../../../utils/constants';
import { media } from '../../../../utils/media';
import NotesContent from './NotesContent';

const Wrapper = styled.div`
  width: ${({$fullWidth, $useCompactWidth})=> {
    if ($fullWidth) return `calc(100% - ${drawerWidthMinimal}px)`;
    // Use compact width when both panels would be open (tablet range where TOC is visible but notes is overlay)
    const width = $useCompactWidth ? drawerWidthResponsiveCompact : drawerWidthResponsive;
    return `calc(100% - ${width})`;
  }};
  background-color: ${toRgba(theme.colors.NEU_999, 0.58)};
  position: fixed;
  right: 0;
  top: ${theme.headerSize};
  height: calc(100% - ${theme.headerSize} *2);

  align-items: flex-end;
  padding: 10px;
  z-index:999;

  display: ${({$makeItOpen})=> $makeItOpen ? 'flex' : 'none'};
  transition: width 0.2s ease-in-out;

  ${media.greaterThan('bigTablet')} {
    display:none;
  }

  ${media.lessThan('tablet')} {
    width:100%;
  }
`

const NotesMobile = ({makeItOpen, fullWidth, themeColor, isNotesOpen}) => {
  // Use compact width when notes would be open alongside TOC (in tablet range)
  const useCompactWidth = isNotesOpen && !fullWidth;

  return (
    <Wrapper $makeItOpen={makeItOpen} $fullWidth={fullWidth} $useCompactWidth={useCompactWidth}>
      <NotesContent themeColor={themeColor} />
    </Wrapper>
  );
}

export default NotesMobile;
